import SearchParamsBase from '../../../../Elements/SearchParamsBase';
import InputTypesEnum from '../../../../Enums/InputTypesEnum';

export default class OrphanedMissingDateAssignmentSearchParams extends SearchParamsBase {
  SelectedCountryCodes: string[] = [];
  SelectedStatuses: string[] = [];
  SelectedOwningOfficeIds: number[] = [];
  SurveyNameOrId: string = '';
  ProjectNameOrId: string = '';
  ClientNameOrId: string = '';
  SelectedPaymentOfficeIds: number[] = [];

  initialize() {
    this.SelectedCountryCodes = [];
    this.SelectedStatuses = [];
    this.SelectedOwningOfficeIds = [];
    this.SurveyNameOrId = '';
    this.ProjectNameOrId = '';
    this.ClientNameOrId = '';
    this.SelectedPaymentOfficeIds = [];
  }

  static getStatusValues() {
    return [
      { label: 'Created', value: '0', disabled: false },
      { label: 'Completed', value: '3', disabled: false },
      { label: 'Collaboration Shop', value: '4', disabled: false },
      { label: 'Hold A', value: '6', disabled: false },
      { label: 'Hold B', value: '7', disabled: false },
      { label: 'Reviewed', value: '8', disabled: false },
      { label: 'Finalized', value: '9', disabled: false },
      { label: 'Emailed', value: '10', disabled: false },
      { label: 'Client Finalized', value: '12', disabled: false },
      { label: 'Locked', value: '15', disabled: false },
      { label: 'Deleted in Apollo', value: '23', disabled: false },
    ];
  }
  //-------------------------------------------
  //-------- Fields for Search Panel ----------
  //-------------------------------------------

  static fieldsInSearchBox = [
    {
      fieldName: 'SelectedCountryCodes',
      label: 'Country',
      className: 'col-4',
      type: InputTypesEnum.CountryCodeMultiChoice,
    },
    {
      fieldName: 'SelectedStatuses',
      label: 'Status',
      className: 'col-4',
      type: InputTypesEnum.MultiChoice,
      options: OrphanedMissingDateAssignmentSearchParams.getStatusValues(),
    },
    {
      fieldName: 'SelectedOwningOfficeIds',
      label: 'Owning Office',
      className: 'col-4',
      type: InputTypesEnum.OfficeOrGroupMultiSelect,
    },
    {
      fieldName: 'SelectedPaymentOfficeIds',
      label: 'Payment Office',
      className: 'col-4',
      type: InputTypesEnum.OfficeOrGroupMultiSelect,
    },
    {
      fieldName: 'ClientNameOrId',
      label: 'Client (Name or Bravo ID or Apollo ID)',
      className: 'col-4',
      type: InputTypesEnum.Text,
    },
    {
      fieldName: 'ProjectNameOrId',
      label: 'Project (Name or Bravo ID)',
      className: 'col-4',
      type: InputTypesEnum.Text,
    },
    {
      fieldName: 'SurveyNameOrId',
      label: 'Survey (Name or Apollo ID)',
      className: 'col-4',
      type: InputTypesEnum.Text,
    },
  ];

  static iconName = 'fas fa-search';
  static saveType = 'OrphanedMissingDateAssignmentSearchParams';
}
